import { useState } from "react";
import useDeleteAndroidTVHome from "../../hooks/use-delete-android-home";
import { TrashSvg } from "../../icons";
import Button from "../common/button";
import Modal from "../common/Modal";
import { toast } from "react-toastify";
import classNames from "classnames";
import { queryClient } from "../../App";
// import { UseFieldArrayRemove } from "react-hook-form";

interface IDeleteAndroidHomeProps {
  categoryName: string;
  type?: string;
  deleteId: string;
  removeField?: () => void;
  disabled?: boolean;
  reLoadData?: boolean
}

const DeleteAndroidHome = ({
  categoryName,
  type,
  deleteId,
  removeField,
  disabled,
  reLoadData
}: IDeleteAndroidHomeProps) => {
  const { mutate: deleteAndroidTVHome, isPending: deleteAndroidTVHomeLoading } =
    useDeleteAndroidTVHome();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleDelete = () => {
    deleteAndroidTVHome(
      { categoryName, type, deleteId },
      {
        onSuccess: async (res) => {
          removeField?.();
          toast.success(res?.result?.message);
          closeModal();
          if(reLoadData){ 
            await queryClient.refetchQueries({ queryKey: ["categories"] });
          }
        },
      }
    );
  };

  return (
    <>
      <div
        onClick={() => !disabled && openModal()}
        className={classNames(
          "h-8 w-8 rounded-full bg-[#FFF1F2] flex items-center justify-center cursor-pointer hover:bg-[#FFE4E6] transition-colors",
          disabled ? "opacity-50" : "cursor-pointer"
        )}
      >
        <TrashSvg color="#E52727" />
      </div>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        title="Are you sure to delete this?"
        className="w-144.75"
      >
        <div className="flex items-center justify-end gap-[18px] mt-9">
          <Button className="w-25.5" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className="w-25.5"
            variant="primary"
            loading={deleteAndroidTVHomeLoading}
            disabled={deleteAndroidTVHomeLoading}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteAndroidHome;
